import type { W2SentenceGuide as Guide } from '../utils/api';
import { W2_CHOICE_LABELS, countChineseCharacters } from '../../../shared/w2SentenceRules.mjs';

export default function W2SentenceGuide({ guide }: { guide: Guide }) {
  return (
    <div className="mt-4 space-y-3 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm leading-6 text-slate-800" data-w2-guide={guide.question_id}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-semibold text-emerald-900">Kata soal: {guide.word}</span>
        <span className="rounded-full bg-white px-2.5 py-0.5 font-medium text-emerald-800">{guide.word_type}</span>
      </div>
      <p><strong>Arti: </strong>{guide.meaning}</p>
      <div>
        <p className="break-words font-semibold text-emerald-900">Pola kalimat: {guide.pattern}</p>
        <p className="mt-1 text-slate-600">{guide.pattern_zh}</p>
      </div>
      <p><strong>Penggunaan: </strong>{guide.usage}</p>
      <div className="space-y-1" data-w2-choices={guide.question_id}>
        {guide.choices.map(group => <p key={group.role}><strong>{W2_CHOICE_LABELS[group.role]}: </strong>{group.words.map(option => `${option.word} (${option.meaning})`).join(' / ')}</p>)}
        <p className="text-xs text-slate-500">Pilihan kata diambil dari bank soal HSK4. Tetap gunakan kata soal dan pilih kata yang sesuai dengan gambar.</p>
      </div>
      <div>
        <p><strong>Contoh: </strong>{guide.example} <span className="text-xs text-slate-500">({countChineseCharacters(guide.example)} karakter Hanzi)</span></p>
        <p className="mt-1 break-words text-slate-600">Susunan kalimat: {guide.breakdown}</p>
      </div>
      <p className="text-xs text-slate-500">Tulis satu kalimat dengan 7–10 karakter Hanzi; tanda baca tidak dihitung. Contoh ini untuk belajar kosakata. Sesuaikan dengan gambar; jawaban dapat bervariasi.</p>
    </div>
  );
}
